import { atom } from 'jotai';

export const uiStateAtomEditBuildHubModal = atom({
    isOpen: false,
    buildHubId: '',
});
